import { render, staticRenderFns } from "./enrollmentlogs.vue?vue&type=template&id=916b455a&"
import script from "./enrollmentlogs.vue?vue&type=script&lang=js&"
export * from "./enrollmentlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports